// Vote-translation helper for the SurveyTracker UI.
//
// 355,075 is the total registered electorate Malta is using as the
// public reference figure for the 2026 cycle. We translate a polling
// lead (in percentage points) into an absolute vote gap by treating
// the lead as the share differential applied across the EXPECTED
// turnout (modelled at 85% of the electorate, matching the most
// recent general-election turnout band). Gives readers a closer
// intuition for the actual ballot-box gap than the full electorate
// would.

export const ELIGIBLE_VOTERS = 355_075;
export const TURNOUT_ASSUMPTION = 0.85;
export const PROJECTED_VOTERS = Math.round(
  ELIGIBLE_VOTERS * TURNOUT_ASSUMPTION,
);

export function leadToVotes(leadPp: number): number {
  return Math.round((leadPp / 100) * PROJECTED_VOTERS);
}
